<main id="main-content" class="not-found-page">
  <section dsCard aria-labelledby="not-found-title">
    <p class="ds-eyebrow">Error 404</p>
    <h1 id="not-found-title">We could not find that page</h1>
    <p>
      The address may be incomplete, outdated, or no longer available. The rest of IQLabTest is
      still working normally.
    </p>
    <div class="not-found-actions">
      <a dsButton size="large" routerLink="/">Start the IQ assessment</a>
      <a dsButton variant="secondary" href="/en/content/">Explore the IQ knowledge center</a>
    </div>
  </section>
</main>
